module.exports = __webpack_public_path__ + "img/login.22207e7a.jpg";